<template>
  <el-table-column
    prop="storage_user.id"
    sortable="custom"
    label="Raktáros"
    show-overflow-tooltip
    min-width="120"
  >
    <template slot-scope="scope">
      {{ scope.row.storage_user_name }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'storage_user.id',
};
</script>
